import { z } from 'zod';

export const LEGACY_API_FAILURE_REASONS = [
  'no_api_url',
  'no_token',
  'api_error',
  'unreachable',
] as const;

export type LegacyApiFailureReason =
  (typeof LEGACY_API_FAILURE_REASONS)[number];

/**
 * Failure branches of the one adapter to the legacy Koa/GraphQL API
 * (apps/frontend/lib/legacyApi.ts, ADR 0016). Emitted from a
 * `protectedProcedure`, so `churchId` is normally in hand: it is the PostHog
 * identity, without it failures pile onto 'unknown'. It is absent only for the
 * anonymous sign-up call (`completeOnboarding`), before any church exists.
 */
export const legacyApiSchemas = {
  /** A call through the legacy adapter failed before returning data. */
  'legacy_api.call_failed': z.object({
    churchId: z.string().optional(),
    message: z.string().optional(),
    operation: z.string(),
    reason: z.enum(LEGACY_API_FAILURE_REASONS),
  }),
};
